import { render, staticRenderFns } from "./veStuCheckNorm.vue?vue&type=template&id=2401d537&scoped=true"
import script from "./veStuCheckNorm.vue?vue&type=script&lang=js"
export * from "./veStuCheckNorm.vue?vue&type=script&lang=js"
import style0 from "./veStuCheckNorm.vue?vue&type=style&index=0&id=2401d537&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2401d537",
  null
  
)

export default component.exports